// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

const getPostZoomLevelCount = async ({
    test,
    postId,
}: {
    test: boolean,
    postId: string,
}): Promise<number> => {
    const functions = getFunctions();
    const handleGetPostZoomLevelCount = httpsCallable<
        Record<
            string,
            boolean | string
        >,
        number
    >(
        functions,
        'getPostZoomLevelCount',
    );
    return handleGetPostZoomLevelCount({
        test,
        postId,
    }).then((result) => {
        const zoomLevelCount = result.data as number;
        return zoomLevelCount;
    }).catch((err) => {
        throw err;
    });
};

export default getPostZoomLevelCount;
